import { render, staticRenderFns } from "./CryptoSweatshirt.vue?vue&type=template&id=2a728d36"
import script from "./CryptoSweatshirt.vue?vue&type=script&lang=js"
export * from "./CryptoSweatshirt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports